import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

export const ListItem = styled.li<SpaceProps>`
  ${space}
`;
